export default "__VITE_ASSET__14NOO5OP__"